import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup, Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

import CardExperiencia from "components/Varios/CardExperiencia.js";
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import { alertService } from 'components/Varios/alert_service.js';

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { UserData } from './Sidebar/Sidebar_Principal';
import CardHistoriaLaboralDP from './Datos Personales/Experiencia/CardHistoriaLaboralDP';
import ButtonDownloadNormalReport from './Varios/ButtonDownloadNormalReport';
import FiltrosExperiencia, { StateFiltrosUsadosExperiencia } from './Datos Personales/Experiencia/FiltrosExperiencia';
import axios from 'axios';

import { authHeaderWithUserData } from "../helpers/auth-header";
import Cargando from './Varios/Cargando';
import { mensajeCamposIncompletos } from './constants';

const id = 1043
const API_URL = configData.SERVER_URL

export class ExperienciaData {
    idhistorialaboral: number = 0;
    idrelacioncontratacion: number = 0;
    idcontratacionotras: number = 0;
    idpersona: number = 0;
    institucion: string = "";
    cargo: string = "";
    tipoexperiencia: string = "";
    motivoingreso: number = 0;
    fechadesde: string = "";
    fechahasta: string = "";
    idpais: number = 0;
    tiempodedicacion: string = "";
    rmu: number = 0;
    fechadesvinculacion: string = "";

    strNombreTipoInstitucion?: string = ""
    strNombreTipoRelacionLaboral?: string = "";
    strNombreTipoDedicacion?: string = "";
    strNombrePais?: string = "";
    strNombreCanton?: string = "";
    convalidado: string = "N";

    refarchivo1: string = "";
    refarchivo2: string = "";

    strEseditable: string = "S";

    iesespol: string = "N";
    estado: string = "A";

    categoriaexperiencia: string = "PC";
}

export type HistoriaLaboral = {
    cargo: string,
    tipoContrato: string,
    desde: string,
    hasta: string,
    tipoDedicacion: string,
    rmu: string,
    fechaDesvinculacion: string,
    refarchivo: string,
    vigente: string,
    descripcionCodigo: string,
    numeroActaTransaccional: string,
    tipoEmpleado: string,
    tipoRelacion: string
    tipoAccion: string
}

export type RequestHistoriaLaboral = {
    historiaMapeada: HistoriaLaboral[],
    vigentes: HistoriaLaboral[]
}

export type ValoresFiltrosHistoriaLaboral = {
    anios: number[],
    cargo: CargoFiltro[],
    tipoRelacion: string[],
    tipoFuncion: string[]
}

export type CargoFiltro = {
    cargo: string,
    tipoFuncion: string
}

interface ExperienciaDataState {
    currentUser: any;
    loading: boolean;
    dtoData: ExperienciaData;
    ExperienciaEspolDataList: ExperienciaData[];
    HistoriaLaboral: RequestHistoriaLaboral;
    ExperienciaOtrasDataList: ExperienciaData[];
    paisList: Array<any>;
    institucionList: Array<any>;
    tipoRelacionLaboralList: Array<any>;
    tiempoDedicacionList: Array<any>;
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    error: null;
    loadingList: boolean;
    ValoresFiltro: ValoresFiltrosHistoriaLaboral,
    loadingHistoriaLaboral: boolean,
    FiltrosUsando: StateFiltrosUsadosExperiencia
}

export class Experiencia extends React.Component<RouteComponentProps<{}>, ExperienciaDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new ExperienciaData(), paisList: [], institucionList: [], tipoRelacionLaboralList: [],
            tiempoDedicacionList: [], ExperienciaEspolDataList: [], HistoriaLaboral: { historiaMapeada: [], vigentes: [] }, ExperienciaOtrasDataList: [], tiposEvidencia: [], ValoresFiltro: { anios: [], cargo: [], tipoRelacion: [], tipoFuncion: [] },
            FiltrosUsando: { cargo: undefined, desde: undefined, funcion: undefined, hasta: undefined, relacion: undefined }, filesData: [], error: null, loadingHistoriaLaboral: false
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarExperiencia = this.cargarExperiencia.bind(this);

        this.cargarHistoriaLaboral = this.cargarHistoriaLaboral.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
        this.descargarReporte = this.descargarReporte.bind(this);
        this.FiltrarCardsHistorial = this.FiltrarCardsHistorial.bind(this);
        this.ObtenerValoresParaFiltrar = this.ObtenerValoresParaFiltrar.bind(this);
    }

    async componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarExperiencia();
                }
            }
        );

        await this.ObtenerValoresParaFiltrar();
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                            loading: false
                        });
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPO DE INSTITUCIÓN
        fetch(API_URL + "DatosExperiencia/TipoInstitucion")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            institucionList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                            loading: false
                        });
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        institucionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPO DE RELACIÓN LABORAL
        fetch(API_URL + "DatosExperiencia/TipoRelacionLaboral")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoRelacionLaboralList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                            loading: false
                        });
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        tipoRelacionLaboralList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIEMPO DEDICACIÓN
        fetch(API_URL + "DatosExperiencia/TiempoDedicacion")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tiempoDedicacionList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                            loading: false
                        });
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        tiempoDedicacionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }
    async ObtenerValoresParaFiltrar() {
        try {
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const respuesta = await axios.get(configData.SERVER_URL + "DatosExperiencia/HistoriaLaboral/ValoresFiltros",
                {
                    headers: authHeaderWithUserData(datosUsuario)
                }
            );
            const valores: ValoresFiltrosHistoriaLaboral = respuesta.data;
            this.setState({ ValoresFiltro: valores })
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                alertService.error("Ha ocurrido un inconveniente al intentar obtener los valores para filtrar su Historia Laboral en ESPOL")
            }
            else {
                alertService.error("Ha ocurrido un error inesperado.")
            }
        }
    }

    FiltrarCardsHistorial(filtrosHistoriaLaboral) {
        this.cargarHistoriaLaboral(filtrosHistoriaLaboral);
    }

    cargarHistoriaLaboral(filtrosHistoriaLaboral) {
        const { desde, hasta, cargo, funcion } = filtrosHistoriaLaboral;
        this.setState({ loadingHistoriaLaboral: true, FiltrosUsando: filtrosHistoriaLaboral })
        var datosUsuario: UserData = authenticationService.currentUserValue;
        const { regimen_usuario } = datosUsuario;

        // if ((regimen_usuario.length === 1 && (regimen_usuario.includes(7) || regimen_usuario.includes(9))) || (regimen_usuario.length > 1 && regimen_usuario.includes(7) && regimen_usuario.includes(0))) {
        var url = new URL(`${API_URL}DatosExperiencia/HistoriaLaboral`);

        var params = { anioDesde: desde ?? "0", anioHasta: hasta ?? "0", cargo: cargo ?? "todos", funcion: funcion ?? "todos" } // or:
        url.search = new URLSearchParams(params).toString();

        fetch(url.href, {
            method: "GET",
        })
            .then(res => res.json())
            .then((result: RequestHistoriaLaboral) => {
                this.setState({
                    HistoriaLaboral: result,
                    loading: false,
                    loadingList: false,
                    tiposEvidencia: this.cargarEvidencias(null),
                    loadingHistoriaLaboral: false
                });
            },
                (error) => {
                    this.setState({
                        loading: false,
                        error,

                        loadingList: false,
                        loadingHistoriaLaboral: false
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
        // }
        // else {
        //     fetch(API_URL + "DatosExperiencia/ExperienciaExtByTipoIdPersonaDesc/E/" + this.state.currentUser.idpersona)
        //         .then(res => res.json())
        //         .then(
        //             (result) => {
        //                 if (result.strEstado === "S") {
        //                     this.setState({
        //                         ExperienciaEspolDataList: result.entTabla,
        //                         loading: false,
        //                         loadingList: false,
        //                         tiposEvidencia: this.cargarEvidencias(null)
        //                     });
        //                 } else {
        //                     alertService.error("Ocurrió un error: " + result.strMensaje)
        //                 }
        //             },
        //             (error) => {
        //                 this.setState({
        //                     loading: false,
        //                     error,
        //                     ExperienciaEspolDataList: [],
        //                     loadingList: false
        //                 });
        //                 alertService.error("Ocurrió un error: " + error)
        //             }
        //         )
        // }
    }

    cargarExperiencia() {
        const filtrosDefault: StateFiltrosUsadosExperiencia = {
            desde: "0",
            hasta: "0",
            cargo: "",
            funcion: "",
            relacion: ""
        }
        this.cargarHistoriaLaboral(filtrosDefault)

        fetch(API_URL + "DatosExperiencia/ExperienciaExtByTipoIdPersonaDesc/O/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            ExperienciaOtrasDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(null)
                        });
                    } else {
                        alertService.error("Ocurrió un error: " + result.strMensaje)
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        ExperienciaOtrasDataList: [],
                        loadingList: false
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;
        this.setState({ dtoData: dto });
    }

    onClickEdit(idhistorialaboral, idrelacioncontratacion, idcontratacionotras) {
        let url = "";
        if (idhistorialaboral !== null) url = API_URL + "DatosExperiencia/ExperienciaExtByTipoIdDesc/H/" + idhistorialaboral;
        if (idrelacioncontratacion != null) url = API_URL + "DatosExperiencia/ExperienciaExtByTipoIdDesc/R/" + idrelacioncontratacion;
        if (idcontratacionotras != null) url = API_URL + "DatosExperiencia/ExperienciaExtByTipoIdDesc/O/" + idcontratacionotras;
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            dtoData: result.entTabla[0],
                            loading: false,
                            tiposEvidencia: this.cargarEvidencias(null)
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new ExperienciaData()
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    onClickDelete(idcontactopersona) {
        //API PARA OBTENER TELEFONOS DE PERSONA
        fetch(API_URL + "FormularioController/DeleteDatosExperiencia/" + idcontactopersona, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success(responseJson["strMensaje"])
                        this.cargarExperiencia();
                    }
                },
                (error) => {
                    alertService.error("Ocurrió un error: " + error)
                })
    }

    onClickLimpiar() {
        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        );
        this.setState({ dtoData: new ExperienciaData() });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({ dtoData: dto });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });
    }

    cargarEvidencias(tipoEvidencia) {
        var tiposEvidencia = [{ "value": "EXP", "label": "Certificado laboral" }];
        return tiposEvidencia;
    }

    descargarEvidencias(experiencia: ExperienciaData) {
        var evidencias = new Array();
        var dto = this.state.dtoData;
        if (experiencia.refarchivo1) {
            let url = "";
            if (experiencia.idhistorialaboral !== null) url = API_URL + "DatosExperiencia/Refarchivo/EXP/H/" + experiencia.idhistorialaboral;
            if (experiencia.idrelacioncontratacion != null) url = API_URL + "DatosExperiencia/Refarchivo/EXP/R/" + experiencia.idrelacioncontratacion;
            if (experiencia.idcontratacionotras != null) url = API_URL + "DatosExperiencia/Refarchivo/EXP/O/" + experiencia.idcontratacionotras;
            evidencias.push({ name: "EXP" + experiencia.idpersona + ".PDF", url: url });
        }
        return evidencias;
    }

    descargarEvidencias2(experiencia: ExperienciaData) {
        var evidencias = new Array();
        var dto = this.state.dtoData;
        if (experiencia.refarchivo2) {
            let url = "";
            if (experiencia.idhistorialaboral !== null) url = API_URL + "DatosExperiencia/Refarchivo2/EXP/H/" + experiencia.idhistorialaboral;
            if (experiencia.idrelacioncontratacion != null) url = API_URL + "DatosExperiencia/Refarchivo2/EXP/R/" + experiencia.idrelacioncontratacion;
            if (experiencia.idcontratacionotras != null) url = API_URL + "DatosExperiencia/Refarchivo2/EXP/O/" + experiencia.idcontratacionotras;
            evidencias.push({ name: "EXP" + experiencia.idpersona + ".PDF", url: url });
        }
        return evidencias;
    }

    descargarReporte() {
        fetch(API_URL + "DatosExperiencia/Reporte/E/" + this.state.currentUser.idpersona)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = this.state.currentUser.identificacion + " - " + this.state.currentUser.apellidos + " - " + this.state.currentUser.nombres;  //nombrearchivo
                    a.click();
                });
            });
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        let formIsValid = true;
        var filesData = this.state.filesData;

        if (dto['fechahasta'] && dto['fechadesde'] > dto['fechahasta']) {
            alertService.error("Error: La fecha hasta debe ser mayor a la fecha desde.");
            return;
        }
        if (dto['fechadesvinculacion'] && dto['fechadesde'] > dto['fechadesvinculacion']) {
            alertService.error("Error: La fecha desvinculación debe ser mayor a la fecha desde.");
            return;
        }

        if ((filesData === undefined || filesData.length === 0) && !dto.refarchivo1) {
            alertService.error("Debe adjuntar evidencia de su experiencia")
            return;
        }

        forma.forEach((value, clave) => {
            if (!value && (clave !== "evidencias" && clave !== "fechahasta" && clave !== "fechadesvinculacion" && clave !== "rmu")) {
                formIsValid = false;
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
            if (clave === 'rmu') dto[clave] = Number(value);
            if (clave === 'fechadesde' || clave === 'fechahasta' || clave === 'fechadesvinculacion') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }
        });

        delete dto['strNombreTipoInstitucion'];
        delete dto['strNombreTipoRelacionLaboral'];
        delete dto['strNombreTipoDedicacion'];
        delete dto['strNombrePais'];
        delete dto['strNombreCanton'];

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "thistorialaboral": dto
        });

        if (formIsValid) {
            if (dto.idhistorialaboral === 0) {
                fetch(API_URL + "FormularioController/PostDatosExperiencia", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else {
                                alertService.success("La experiencia se ha actualizado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('idhistorialaboral', responseJson.thistorialaboral.idhistorialaboral);

                                    fetch(API_URL + "FormularioController/PostFilesDatosExperiencia", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(success => {
                                            // Do something with the successful response
                                        })
                                        .catch(error => alertService.error(error) //console.log(error)
                                        );
                                }

                                this.cargarExperiencia();
                                this.onClickLimpiar();
                            }
                        },
                        (error) => {
                            alertService.error(error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosExperiencia", {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else {
                                alertService.success("La experiencia se ha registrado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('idhistorialaboral', responseJson.thistorialaboral.idhistorialaboral);

                                    fetch(API_URL + "FormularioController/PostFilesDatosExperiencia", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(success => {
                                            // Do something with the successful response
                                        })
                                        .catch(error => alertService.error(error) //console.log(error)
                                        );
                                }

                                this.cargarExperiencia();
                                this.onClickLimpiar();
                            }
                        },
                        (error) => {
                            alertService.error(error)
                        })
            }
        }
        else {
            alertService.error(mensajeCamposIncompletos());
        }
    }

    private handleCancel(e) {
        e.preventDefault();

        this.props.history.push("/fetch-contactos");
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    public render() {
        if (this.state.loadingHistoriaLaboral) {
            return <Cargando />
        }
        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>

            </div>

            : this.renderForm(this.state.paisList, this.state.institucionList, this.state.tipoRelacionLaboralList,
                this.state.tiempoDedicacionList, this.state.ExperienciaEspolDataList, this.state.HistoriaLaboral, this.state.ExperienciaOtrasDataList,
                this.state.tiposEvidencia);

        return <div className="content">

            {contents}

        </div>;
    }

    // Returns the HTML Form to the render() method.

    private renderForm(paisList: Array<any>, institucionList: Array<any>, tipoRelacionLaboralList: Array<any>, tiempoDedicacionList: Array<any>,
        ExperienciaEspolDataList: ExperienciaData[], HistoriaLaboralDataList: RequestHistoriaLaboral, ExperienciaOtrasDataList: ExperienciaData[], tiposEvidencia: Array<any>) {
        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">EXPERIENCIA</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>

                                        </div>
                                        :
                                        <Tabs defaultActiveKey="experienciaESPOL">
                                            <Tab eventKey="experienciaESPOL" title="ESPOL">
                                                {(ExperienciaEspolDataList.length != 0) ?
                                                    <Row form>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.descargarReporte()}>Reporte</Button>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    :
                                                    null}
                                                {ExperienciaEspolDataList.length > 0 &&
                                                    <React.Fragment>
                                                        <Row id="lista">
                                                            {ExperienciaEspolDataList.map((dto, index) =>
                                                                <CardExperiencia
                                                                    key={dto.idhistorialaboral ? 'H' + dto.idhistorialaboral : (dto.idrelacioncontratacion ? 'R' + dto.idrelacioncontratacion : (dto.idcontratacionotras ? 'O' + dto.idcontratacionotras : ''))}
                                                                    tipo={dto.idhistorialaboral}
                                                                    institucion={dto.institucion}
                                                                    cargo={dto.cargo}
                                                                    strNombreTipoInstitucion={dto.strNombreTipoInstitucion}
                                                                    strNombreTipoRelacionLaboral={dto.strNombreTipoRelacionLaboral}
                                                                    fechadesde={dto.fechadesde}
                                                                    fechahasta={dto.fechahasta}
                                                                    strNombrePais={dto.strNombrePais}
                                                                    strNombreTipoDedicacion={dto.strNombreTipoDedicacion}
                                                                    tiempodedicacion={dto.tiempodedicacion}
                                                                    rmu={dto.rmu}
                                                                    number={(index + 1) + " / " + ExperienciaEspolDataList.length}
                                                                    fechadesvinculacion={dto.fechadesvinculacion}
                                                                    evidencias={this.descargarEvidencias(dto)}
                                                                    evidencias2={this.descargarEvidencias2(dto)}
                                                                    eventEdit={() => this.onClickEdit(dto.idhistorialaboral, dto.idrelacioncontratacion, dto.idcontratacionotras)}
                                                                    eventDelete={() => dto.idhistorialaboral ? this.onClickDelete(dto.idhistorialaboral) : null} />
                                                            )}
                                                        </Row>
                                                    </React.Fragment>
                                                }
                                                {
                                                    this.state.ValoresFiltro.anios.length > 0 && (

                                                        <FiltrosExperiencia
                                                            filtro={this.state.ValoresFiltro}
                                                            onClickFiltrar={(filtros) => this.FiltrarCardsHistorial(filtros)}
                                                            filtrosUsando={this.state.FiltrosUsando}
                                                        />
                                                    )
                                                }
                                                {
                                                    this.state.loadingHistoriaLaboral && <Cargando />
                                                }
                                                {
                                                    HistoriaLaboralDataList.vigentes.length > 0 && !this.state.loadingHistoriaLaboral &&
                                                    (
                                                        <React.Fragment>

                                                            <Row className="justify-content-center">
                                                                <span className="botonDescargarHistorialOculto ">
                                                                    <ButtonDownloadNormalReport api={`DatosExperiencia/HistoriaLaboral/Reporte`} />
                                                                </span>
                                                            </Row>
                                                            <Row>
                                                                <Col className="containerPrimerContratoVigente" >
                                                                    <span className="descripcionPrimerVigente">
                                                                        <span className='cargo'>Contrato vigente: <strong>{HistoriaLaboralDataList.vigentes[0].cargo}</strong>     </span>
                                                                        <span className='desde'><span>Fecha Desde: <strong>{HistoriaLaboralDataList.vigentes[0].desde}</strong></span></span>
                                                                    </span>
                                                                    <span className="botonDescargarHistorial">
                                                                        <ButtonDownloadNormalReport api={`DatosExperiencia/HistoriaLaboral/Reporte`} />
                                                                    </span>

                                                                </Col>
                                                            </Row>

                                                            {HistoriaLaboralDataList.vigentes.map((historia, indiHistoria) => {
                                                                if (historia.vigente == "SI" && indiHistoria > 0) {
                                                                    return (
                                                                        <Row key={"cardNuevaHistoria " + indiHistoria}>
                                                                            <Col xl={12} key={"Column " + indiHistoria + "cardHistoriaLaboralVigentes"} >
                                                                                <div className="containerContratosVigentes">
                                                                                    <div className='cargo'>Contrato vigente: <strong>{historia.cargo}</strong>     </div>
                                                                                    <div className='desde'><span>Fecha Desde: <strong>{historia.desde}</strong></span></div>
                                                                                </div>
                                                                            </Col>

                                                                        </Row>
                                                                    )
                                                                }
                                                            })
                                                            }

                                                        </React.Fragment>

                                                    )
                                                }
                                                {
                                                    HistoriaLaboralDataList.historiaMapeada.length > 0 &&
                                                    (
                                                        <Row>

                                                            {
                                                                HistoriaLaboralDataList.historiaMapeada.map((historia, indiHistoria) => {
                                                                    return (

                                                                        <Col xl={4} lg={4} md={6} key={"Column " + indiHistoria + "cardHistoriaLaboral"} className="mt-3">
                                                                            <CardHistoriaLaboralDP
                                                                                datosExperiencia={historia}
                                                                                numeroCard={indiHistoria + 1}
                                                                                valorTotal={HistoriaLaboralDataList.historiaMapeada.length}
                                                                            />
                                                                        </Col>
                                                                    )
                                                                })
                                                            }
                                                        </Row>
                                                    )
                                                }

                                            </Tab>
                                            <Tab eventKey="experienciaOtras" title="OTRAS">
                                                <div>
                                                    <form onSubmit={this.handleSave} id="formTelefonos">
                                                        <Row form>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="institucion">Institución*</Label>
                                                                    <Input maxLength="250" type="text" name="institucion" id="institucion" value={this.state.dtoData.institucion} onChange={this.handleChange} required />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="cargo">Cargo*</Label>
                                                                    <Input maxLength="100" type="text" name="cargo" id="cargo" value={this.state.dtoData.cargo} onChange={this.handleChange} required />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="tipoexperiencia">Tipo institución*</Label>
                                                                    <SelectItem
                                                                        options={institucionList}
                                                                        value={this.state.dtoData.tipoexperiencia}
                                                                        onChange={this.handleSelectChange}
                                                                        placeholder=""
                                                                        name="tipoexperiencia"
                                                                        id="tipoexperiencia"
                                                                        icon="fa-caret-right"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="motivoingreso">Tipo relación laboral*</Label>
                                                                    <SelectItem
                                                                        options={tipoRelacionLaboralList}
                                                                        value={this.state.dtoData.motivoingreso}
                                                                        onChange={this.handleSelectChange}
                                                                        placeholder=""
                                                                        name="motivoingreso"
                                                                        id="motivoingreso"
                                                                        icon="fa-caret-right"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="fechadesde">Desde*</Label>
                                                                    <Datepicker
                                                                        value={this.state.dtoData.fechadesde}
                                                                        name="fechadesde"
                                                                        id="fechadesde"
                                                                        onChange={this.handleSelectChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="fechahasta">Hasta</Label>
                                                                    <Datepicker
                                                                        value={this.state.dtoData.fechahasta}
                                                                        name="fechahasta"
                                                                        id="fechahasta"
                                                                        onChange={this.handleSelectChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>

                                                        <Row form>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="idpais">País*</Label>
                                                                    <SelectItem
                                                                        options={paisList}
                                                                        value={this.state.dtoData.idpais}
                                                                        onChange={this.handleSelectChange}
                                                                        placeholder=""
                                                                        name="idpais"
                                                                        id="idpais"
                                                                        icon="pais"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="tiempodedicacion">Tiempo de dedicación*</Label>
                                                                    <SelectItem
                                                                        options={tiempoDedicacionList}
                                                                        value={this.state.dtoData.tiempodedicacion}
                                                                        onChange={this.handleSelectChange}
                                                                        placeholder=""
                                                                        name="tiempodedicacion"
                                                                        id="tiempodedicacion"
                                                                        icon="tiempo_dedicacion"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="hide">
                                                                <Label for="rmu">Remuneración</Label>
                                                                <FormGroup>
                                                                    <InputGroup>
                                                                        <Input type="number" step=".01" name="rmu" id="rmu" placeholder="" value={this.state.dtoData.rmu} onChange={this.handleChange}  />
                                                                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                            <Icon kind="moneda" fill='#FFFFFF' width={27} height={27} />
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="fechadesvinculacion">Desvinculación</Label>
                                                                    <Datepicker
                                                                        value={this.state.dtoData.fechadesvinculacion}
                                                                        name="fechadesvinculacion"
                                                                        id="fechadesvinculacion"
                                                                        onChange={this.handleSelectChange}
                                                                        placeholder="dd/mm/aaaa"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Label for="fechagraduacion">Evidencia</Label>
                                                                <FormGroup row>
                                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                                        <InputFileUpload
                                                                            icon="upload"
                                                                            onChange={this.handleFileUploadChange}
                                                                            name="EXP"
                                                                            placeholder={this.state.dtoData.refarchivo1 ? "Actualizar Certificado laboral" : "Subir Certificado laboral"} />
                                                                    </Col>
                                                                    <InputFileDownload
                                                                        id="downloadRef1"
                                                                        refarchivo={this.state.dtoData.refarchivo1}
                                                                        name={this.descargarEvidencias(this.state.dtoData).length > 0 ? this.descargarEvidencias(this.state.dtoData)[0]["name"] : ""}
                                                                        url={this.descargarEvidencias(this.state.dtoData).length > 0 ? this.descargarEvidencias(this.state.dtoData)[0]["url"] : ""}
                                                                    />

                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row form>
                                                            <Col md={12}>
                                                                <FormGroup>
                                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                                    {this.state.dtoData.strEseditable === "S" ?
                                                                        <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                                        : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </form >
                                                    <br />
                                                </div>
                                                <Row id="lista">
                                                    {ExperienciaOtrasDataList.map((dto, index) =>
                                                        <CardExperiencia
                                                            key={dto.idhistorialaboral ? 'H' + dto.idhistorialaboral : (dto.idrelacioncontratacion ? 'R' + dto.idrelacioncontratacion : (dto.idcontratacionotras ? 'O' + dto.idcontratacionotras : ''))}
                                                            tipo={dto.idhistorialaboral}
                                                            institucion={dto.institucion}
                                                            cargo={dto.cargo}
                                                            strNombreTipoInstitucion={dto.strNombreTipoInstitucion}
                                                            strNombreTipoRelacionLaboral={dto.strNombreTipoRelacionLaboral}
                                                            fechadesde={dto.fechadesde}
                                                            fechahasta={dto.fechahasta}
                                                            strNombrePais={dto.strNombrePais}
                                                            strNombreTipoDedicacion={dto.strNombreTipoDedicacion}
                                                            tiempodedicacion={dto.tiempodedicacion}
                                                            rmu={dto.rmu}
                                                            number={(index + 1) + " / " + ExperienciaOtrasDataList.length}
                                                            fechadesvinculacion={dto.fechadesvinculacion}
                                                            evidencias={this.descargarEvidencias(dto)}
                                                            evidencias2={[]}
                                                            eventEdit={() => this.onClickEdit(dto.idhistorialaboral, dto.idrelacioncontratacion, dto.idcontratacionotras)}
                                                            eventDelete={() => dto.idhistorialaboral ? this.onClickDelete(dto.idhistorialaboral) : null} />
                                                    )}
                                                </Row>
                                            </Tab>

                                        </Tabs>

                                    )}

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default Experiencia;